var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3052 40.0015H3.68359V0.244626C3.68359 0.110332 3.8046 0.00146484 3.95386 0.00146484H10.0349C10.1842 0.00146484 10.3052 0.110332 10.3052 0.244626V40.0015Z",
    fill: "#003F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6292 40.0015H13.0076V14.1049C13.0076 13.9706 13.1286 13.8617 13.2779 13.8617H19.3589C19.5082 13.8617 19.6292 13.9706 19.6292 14.1049V40.0015Z",
    fill: "#003F7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9537 40.0015H22.3321V22.9802C22.3321 22.8459 22.4531 22.7371 22.6024 22.7371H28.6835C28.8327 22.7371 28.9537 22.8459 28.9537 22.9802V40.0015Z",
    fill: "#003F7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.278 40.0016H31.6564V28.9377C31.6564 28.8034 31.7774 28.6946 31.9267 28.6946H38.0078C38.157 28.6946 38.278 28.8034 38.278 28.9377V40.0016Z",
    fill: "#003F7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.845581 40.0015L40.8456 40.0015",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.c49df429aa619cdfc49cac40e0101043.svg";
export { ForwardRef as ReactComponent };